import { withTranslation } from 'react-i18next';
import NotFound from './NotFound';

export default withTranslation()(NotFound);
